import './style.scss'
import { Button, Input, message, Modal } from 'antd'
import { FC, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { showPlanModal } from '@/libs/util'
import VoiceModal from '@/views/create-video/components/VoiceModal'
import { RightOutlined } from '@ant-design/icons'

interface IProps {
  open: boolean
  avatar?: any
  onCancel?: () => void
  onSuccess?: (form?: any) => void
}

const AvatarFormModal: FC<IProps> = (props) => {
  const { t } = useTranslation(['avatar', 'system'])
  const { open, avatar, onCancel, onSuccess } = props
  const [selectVoice, setSelectVoice] = useState<any>()
  const [voiceModalOpen, setVoiceModalOpen] = useState(false)
  const [form, setForm] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const nameRef = useRef<any>()

  useEffect(() => {
    if (open) {
      setForm({
        title: '',
        description: '',
        self_introduction: ''
      })
      setSelectVoice(undefined)
      setLoading(false)
      nameRef.current?.focus()
    }
  }, [open])

  const onVoiceChange = (voice: any) => {
    setSelectVoice(voice)
  }

  const onFormChange = (key: string, e: any) => {
    setForm({
      ...form,
      [key]: e.target.value
    })
  }

  const submitForm = async () => {
    const { title } = form
    if (!title?.trim()) {
      nameRef.current?.focus()
      return message.warning(t('avatar.enter_name_warning'))
    }
    setLoading(true)
    await onSuccess?.({
      ...form,
      face_oss_key: avatar?.oss_key,
      tts_voice_id: selectVoice?.id,
      tts_voice_is_community: !!selectVoice?.parent_id
    })
    setLoading(false)
  }

  return (
    <>
      <Modal
        title={t('avatar.create_avatar')}
        className="commom-modal avatar-form-modal"
        footer={null}
        width={700}
        onCancel={() => onCancel?.()}
        open={open}
        maskClosable={false}
        zIndex={99}
      >
        <div className="avatar-form-modal-content">
          <div className="wrapper">
            <div className="wrapper__left">
              <div className="photo">{avatar?.url && <img src={avatar.url} />}</div>
            </div>
            <div className="wrapper__right">
              <div className="form-item">
                <div className="title">
                  <label className="red">*</label>
                  <label>{t('avatar.name')}</label>
                </div>
                <div className="content">
                  <Input
                    value={form?.title}
                    ref={nameRef}
                    placeholder={t('avatar.name_placeholder')}
                    maxLength={20}
                    onChange={onFormChange?.bind(this, 'title')}
                  />
                </div>
              </div>

              <div className="form-item">
                <div className="title">{t('avatar.self_introduction')}</div>
                <div className="content">
                  <Input.TextArea
                    placeholder={t('avatar.self_intro_placeholder')}
                    maxLength={200}
                    value={form?.self_introduction}
                    onChange={onFormChange?.bind(this, 'self_introduction')}
                  />
                </div>
              </div>

              <div className="form-item">
                <div className="title">{t('avatar.voice')}</div>
                <div className="content">
                  <div className="form-voice-box" onClick={() => setVoiceModalOpen(true)}>
                    {selectVoice ? (
                      <>
                        <div className="left">
                          <img src={selectVoice?.group_cover_url} />
                        </div>
                        <div className="center ellipsis">
                          <span>{selectVoice?.group_title}</span>
                          <span className="name">{selectVoice?.display_name}</span>
                        </div>
                      </>
                    ) : (
                      <div className="center">{t('avatar.select_voice')}</div>
                    )}
                    <div className="right">
                      <RightOutlined />
                    </div>
                  </div>
                </div>
              </div>
              <div className="footer">
                <Button loading={loading} type="primary" onClick={submitForm}>
                  {loading ? t('avatar.creating_avatar') : t('avatar.create_avatar')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <VoiceModal
        open={voiceModalOpen}
        selectTts={selectVoice}
        onCancel={() => setVoiceModalOpen(false)}
        upgradePlan={showPlanModal}
        onSelect={onVoiceChange}
      />
    </>
  )
}

export default AvatarFormModal
